export default __webpack_public_path__ + "locales/az/OAuth.json?hash=070709c5e2da0f58c56d33dd4597bc41";